import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className="app">
      {/* Animated background elements */}
      <div className="background-wrapper">
        <div className="bg-orb orb-1"></div>
        <div className="bg-orb orb-2"></div>
        <div className="bg-orb orb-3"></div>
      </div>

      {/* Floating particles */}
      <div className="particles-wrapper">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${15 + Math.random() * 10}s`
            }}
          ></div>
        ))}
      </div>

      {/* Main content */}
      <div className="content-wrapper">
        {/* Logo container with animation */}
        <div className={`logo-container ${isLoaded ? 'loaded' : ''}`}>
          <div className="logo-wrapper">
            <div className="logo-glow"></div>
            <img 
              src="/anoon-logo.png" 
              alt="Anoon Solutions" 
              className="logo"
            />
          </div>
        </div>

        {/* Main heading */}
        <div className={`heading-container ${isLoaded ? 'loaded' : ''}`}>
          <h1 className="main-heading">Under Improvement</h1>
          <div className="heading-underline"></div>
        </div>

        {/* Version badge */}
        <div className={`version-container ${isLoaded ? 'loaded' : ''}`}>
          <div className="version-badge">
            <div className="version-glow"></div>
            <div className="version-content">
              <span className="version-text">Version 2.0</span>
            </div>
          </div>
        </div>

        {/* Description */}
        <p className={`description ${isLoaded ? 'loaded' : ''}`}>
          We're crafting something extraordinary. Our team is working hard to bring you an enhanced experience with cutting-edge solutions.
        </p>

        {/* Loading indicator */}
        <div className={`loading-indicator ${isLoaded ? 'loaded' : ''}`}>
          <div className="loading-container">
            <div className="dots">
              <div className="dot dot-1"></div>
              <div className="dot dot-2"></div>
              <div className="dot dot-3"></div>
            </div>
            <span className="loading-text">Building the future</span>
          </div>
        </div>

        {/* Footer text */}
        <div className={`footer-text ${isLoaded ? 'loaded' : ''}`}>
          <p>Stay tuned for updates</p>
        </div>
      </div>
    </div>
  );
}

export default App;
